import React from 'react'
import { compose } from 'recompose'
import _ from 'lodash/fp'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withStyles from '@material-ui/core/styles/withStyles'
import { Typography, TextField } from '@material-ui/core'
import colors from '@fe/ui/colors'

import { sendBuddyInviteLoader } from './buddiesQueries'
import { validateEmail } from '../Auth/Common'

const styles = theme => ({
  // TBD
})

const INVITATION_STATUS = {
  none: 'none',
  waiting: 'waiting',
  sent: 'sent',
  error: 'error'
}

function AddBuddyDialog ({
  open, // boolean
  hide, // function
  sendBuddyInvite // function - courtesy of `sendBuddyInviteLoader`
}) {
  const [email, setEmail] = React.useState('')
  const [status, setStatus] = React.useState(INVITATION_STATUS.none)
  const formDisabled = React.useMemo(() =>
    // validateEmail is truthy if invalid..
    validateEmail(email) || _.includes(status, [INVITATION_STATUS.sent, INVITATION_STATUS.waiting]),
  [email, status])
  const handleChangeEmail = React.useCallback(e => { setEmail(e.target.value) }, [setEmail])
  const handleInvite = React.useCallback(() => {
    setStatus(INVITATION_STATUS.waiting)
    sendBuddyInvite({
      variables: { email }
    }).then(({ data }) => {
      setStatus(_.get('sendBuddyInvite', data) ? INVITATION_STATUS.sent : INVITATION_STATUS.error)
    })
  }, [email, sendBuddyInvite])
  return (
    <Dialog
      open={open}
      onBackdropClick={hide}
      onEscapeKeyDown={hide}
    >
      <DialogTitle>
        Invite a friend to GLFR
      </DialogTitle>
      <DialogContent>

        {status === INVITATION_STATUS.sent
          ? (
            <Typography
              variant='caption'
            >
              Invitation has been sent!
            </Typography>
            )
          : (
            <>
              <Typography
                variant='caption'
              >
                Invite a friend to become a part of the GLFR community, so you can follow each other's games and easily add each other as markers.
              </Typography>

              <div style={{ paddingTop: '1em' }}>
                <TextField
                  fullWidth
                  label='User Email'
                  value={email}
                  type='text'
                  onChange={handleChangeEmail}
                />
              </div>

              {status === INVITATION_STATUS.error && (
                <Typography
                  variant='caption'
                  style={{ color: colors.primaryDarkRed }}
                >
                  Failed to send invitation. Please try again or <a href='mailto:support@glfr.com'>contact support</a> for help.
                </Typography>
              )}
            </>
            )}

      </DialogContent>
      {status === INVITATION_STATUS.sent
        ? (
          <DialogActions>
            <Button
              onClick={hide}
              color='primary'
            >
              OK
            </Button>
          </DialogActions>
          )
        : (
          <DialogActions>
            <Button
              onClick={hide}
              color='secondary'
            >
              Cancel
            </Button>
            <Button
              onClick={handleInvite}
              color='primary'
              autoFocus
              disabled={formDisabled}
            >
              Send Invite
            </Button>
          </DialogActions>
          )}
    </Dialog>
  )
}

export default compose(
  withStyles(styles),
  sendBuddyInviteLoader
)(AddBuddyDialog)
